// Hooks
import { useEffect, useState } from 'react';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

// Components
import Button from '../Button/Button';
import Carousel from '../Carousel/Carousel';
import ImageBlock from '../ImageBlock/ImageBlock';

// Utils
import toCamelCase from '../../utils/toCamelCase';

let headingIndex = false;

const Chapter = (props) => {
  const { id, title, figure, content, scrollRefs, scrollMargin, handleScroll } = props;

  const [renderedContent, setRenderedContent] = useState(false);
  const [hasRendered, setHasRendered] = useState(false);

  const RENDER_CHAPTER_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <p className="Chapter-paragraph">{children}</p>,
      [BLOCKS.OL_LIST]: (node, children) => <ol className="Chapter-orderedList">{children}</ol>,
      [BLOCKS.UL_LIST]: (node, children) => <ul className="Chapter-unorderedList">{children}</ul>,
      [BLOCKS.HEADING_3]: (node, children) => {
        headingIndex += 1;

        return (
          <h3
            className="Chapter-subheading"
            id={toCamelCase(node.content[0].value).replace(/[^a-zA-Z ]/g, '')}
            data-index={headingIndex}
          >
            {children}
          </h3>
        );
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const entry = node.data.target;
        const contentType = entry.sys.contentType.sys.id;
        const fields = entry.fields;
        switch (contentType) {
          case 'button':
            return (
              <Button
                label={fields.text}
                url={fields.url}
                target={fields.openInNewTab ? '_blank' : undefined}
                modifier="Button--electricPurple Button--chapter"
              />
            );
          case 'carousel':
            return <Carousel {...fields} modifier="Carousel--chapter" hideTitle />;
          case 'image':
            return <ImageBlock {...fields} />;
          default:
            return null;
        }
      },
    },
  };

  const renderChapterNodes = () => {
    headingIndex = 0;
    const markup = documentToReactComponents(content, RENDER_CHAPTER_OPTIONS);
    setRenderedContent(markup);
  };

  useEffect(() => {
    if (!scrollMargin) return false;
    const observer = new IntersectionObserver(handleScroll, scrollMargin);
    observer.observe(scrollRefs[id].current);
    return () => observer.disconnect();
  }, [scrollMargin]);

  useEffect(() => {
    if (!hasRendered) {
      renderChapterNodes();
      setHasRendered(true);
    }
  }, []);

  return (
    <div className="Chapter" ref={scrollRefs[id]} id={id}>
      <div className="Chapter-inner">
        <div className="Chapter-header">
          {figure && (
            <div className="Chapter-illustration">
              <svg className="Chapter-graphic">
                <use xlinkHref={figure} />
              </svg>
            </div>
          )}
          {title && (
            <h2 id={toCamelCase(title)} className="Chapter-title">
              {title}
            </h2>
          )}
        </div>
        {renderedContent && <div className="Chapter-content">{renderedContent}</div>}
      </div>
    </div>
  );
};

export default Chapter;
